import React from "react";
import { ArrowLeft, ChevronDown } from "lucide-react";
import { t as translate } from "@/i18n/dict";

export default function FunnelHeader({ step, totalSteps, onBack, canBack = true, lang, langs, onLangChange }) {
  const tt = (k) => translate(lang, k);
  return (
    <header className="sticky top-0 z-30 bg-brand-bone/85 backdrop-blur-xl border-b border-brand-line">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={onBack}
          disabled={!canBack}
          data-testid="funnel-back-btn"
          className={`w-10 h-10 rounded-full border flex items-center justify-center transition-all ${
            canBack
              ? "border-brand-line bg-white text-brand-dark hover:border-brand-dark hover:shadow-soft"
              : "border-transparent text-brand-line cursor-not-allowed"
          }`}
          aria-label={tt("common.back")}
        >
          <ArrowLeft strokeWidth={1.5} className="w-4 h-4 rtl-flip" />
        </button>

        <div className="flex-1 flex flex-col items-center min-w-0">
          <span className="font-display text-base font-semibold text-brand-dark tracking-tight">{tt("brand.name")}</span>
          <span className="text-[10px] tracking-[0.2em] uppercase font-bold text-brand-muted mt-0.5" data-testid="funnel-progress">
            {tt("common.step")} {step} / {totalSteps}
          </span>
        </div>

        <div className="relative">
          <select
            value={lang}
            onChange={(e) => {
              const next = langs.find((l) => l.code === e.target.value);
              onLangChange(next?.code, next?.dir);
            }}
            data-testid="funnel-lang-select"
            className="appearance-none bg-white border border-brand-line rounded-full pl-3 pr-7 h-10 text-xs font-semibold text-brand-dark focus:outline-none focus:border-brand-primary"
          >
            {langs.map((l) => (
              <option key={l.code} value={l.code}>
                {l.code.toUpperCase()}
              </option>
            ))}
          </select>
          <ChevronDown strokeWidth={2} className="w-3 h-3 text-brand-muted absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none" />
        </div>
      </div>
      {/* progress bar */}
      <div className="h-[2px] bg-brand-line/60">
        <div
          className="h-full bg-brand-primary transition-all duration-500"
          style={{ width: `${(step / totalSteps) * 100}%` }}
        />
      </div>
    </header>
  );
}
